import React from "react";
import {get} from "lodash";

const AccessPDFPod = ({ podule }) => {
  const longform = get(podule, 'media.long_form.html');
  return (
    <div className="text-center mb-4">
      <div className="d-flex justify-content-center">
        <iframe
          src={`https://docs.google.com/gview?url=${podule.location}&embedded=true`}
          width="100%"
          height="800px"
        >
        </iframe>
      </div>
      <h4 className="mt-4 mb-4"><i className="fas fa-file-pdf"></i> {podule.name}</h4>
      {longform && (
        <>
          <hr className="mt-4 mb-4" />
          <div dangerouslySetInnerHTML={{ __html: longform }}></div>
        </>
      )}
    </div>
  );
};

export default AccessPDFPod;
